export default __webpack_public_path__ + "static/media/marvelous-kraver.a287240d.svg";